import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Layout } from 'antd';
import styled from 'styled-components';
import CogniteLogo from 'components/CogniteLogo';
import chartIcon from 'assets/charticon.svg';
import threedIcon from 'assets/3dicon.svg';
import infographicsIcon from 'assets/infographicsicon.svg';
import infoIcon from 'assets/infoicon.svg';
import roadmapIcon from 'assets/roadmapicon.svg';
import assetIcon from 'assets/asseticon.svg';

const { Header, Content, Sider } = Layout;

const StyledLogo = styled.div`
  height: 50px;
  background: #00487d;
  padding: 12px 20px;
`;

const SideMenu = styled.nav`
  color: white;
  flex-direction: column;
  display: flex;

  width: 100%;
`;

const StyledNavLink = styled(NavLink)`
  padding: 8px;
  width: 100%;

  &.active {
    background: #4592b2 !important;
  }

  &:hover {
    background: #70706f;
  }
`;

const StyledTitle = styled.h2`
  padding-left: 10px;
  color: white;
  float: left;
`;

const PageLayout = ({ children, email }) => (
  <Layout style={{ height: '100vh' }}>
    <Sider width={90} style={{ maxHeight: '100vh', background: '#00253A' }}>
      <StyledLogo>
        <CogniteLogo />
      </StyledLogo>
      <SideMenu>
        <StyledNavLink to="/charts">
          <img src={chartIcon} alt="charts" />
        </StyledNavLink>
        <StyledNavLink to="/infographics">
          <img src={infographicsIcon} alt="inforaphics" />
        </StyledNavLink>
        {email.match(/@cognite.com/gi) && (
          <StyledNavLink to="/assets">
            <img src={assetIcon} alt="assets" />
          </StyledNavLink>
        )}
        <StyledNavLink to="/3d">
          <img src={threedIcon} alt="info" />
        </StyledNavLink>
        <StyledNavLink to="/info">
          <img src={infoIcon} alt="info" />
        </StyledNavLink>
        <StyledNavLink to="/roadmap">
          <img src={roadmapIcon} alt="roadmap" />
        </StyledNavLink>
      </SideMenu>
    </Sider>
    <Layout>
      <Header
        style={{
          background: '#00487d',
          padding: 0,
          height: '50px',
          lineHeight: '50px',
        }}
      >
        <StyledTitle>Operational Intelligence</StyledTitle>
        <div
          style={{
            width: '50%',
            display: 'flex',
            flexDirection: 'row-reverse',
            float: 'right',
          }}
        >
          <h3
            style={{
              color: 'white',
              marginRight: '10px',
              marginLeft: '10px',
            }}
          >
            {email}
          </h3>
        </div>
      </Header>
      <Content style={{ margin: '0 16px', position: 'relative' }}>
        <div style={{ margin: '16px 0 0 0' }}>{children}</div>
      </Content>
    </Layout>
  </Layout>
);

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  email: PropTypes.string.isRequired,
};

export default connect(state => ({
  email: state.auth.email,
  location: state.router.location.pathname,
  experimental: state.experimental,
  pathname: state.router.location.pathname,
}))(PageLayout);



// WEBPACK FOOTER //
// ./src/containers/PageLayout.js